import cn from 'classnames';
import StarIcon from './star.svg';
// Стили
import './RatingMovie.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RatingMovie = function RatingMovie(_ref) {
    var value = _ref.value, className = _ref.className, size = _ref.size;
    if (value == null) {
        return /*#__PURE__*/ _jsx("span", {
            className: "rating-movie rating-movie--empty",
            children: "\u2014"
        });
    }
    var ratingClass = '';
    if (value >= 8) {
        ratingClass = 'rating-movie--excellent';
    }
    else if (value >= 7) {
        ratingClass = 'rating-movie--good';
    }
    else if (value >= 6) {
        ratingClass = 'rating-movie--average';
    }
    else {
        ratingClass = 'rating-movie--bullshit';
    }
    return /*#__PURE__*/ _jsxs("span", {
        className: cn('rating-movie', ratingClass, "rating-movie--".concat(size), className),
        children: [/*#__PURE__*/ _jsx(StarIcon, {
                className: "rating-movie__icon",
                width: 20,
                height: 20,
                "aria-hidden": "true"
            }), /*#__PURE__*/ _jsx("span", {
                className: "rating-movie__info",
                children: Math.round(value * 10) / 10
            })]
    });
};
export default RatingMovie;
